export var rule = function (_node) {
    return '----';
};
//# sourceMappingURL=rule.js.map